import { useCurrentUser } from "@roastery/auth";
import { useTranslation } from "@roastery/i18n";
import { LegalLinks as BaseLegalLinks } from "@roastery/ui";

/**
 * "Privacy and terms", in this application's words, pointing at the documents the installation
 * publishes (US-37.9, L-11).
 *
 * <p>The address and the edition come from `/api/v1/me`, which is the only thing that knows them:
 * the same image serves installations run by different companies, so the operator's name cannot be
 * a constant here any more than it can be in the documents themselves.
 */
export function LegalLinks({ className, testId }: { className?: string; testId?: string }) {
  const { t } = useTranslation();
  const { user } = useCurrentUser();
  const baseUrl = user?.legalUrl;
  if (!baseUrl) {
    return null;
  }
  const operator = user?.operator?.name;
  return (
    <BaseLegalLinks
      baseUrl={baseUrl}
      locale={user?.locale ?? "pl"}
      labels={{
        privacy: t("legal.privacy"),
        terms: t("legal.terms"),
        version: user?.legalVersion ? t("legal.version", { version: user.legalVersion }) : undefined,
      }}
      notice={operator ? t("legal.operator", { operator }) : undefined}
      className={className}
      testId={testId}
    />
  );
}
